module.exports = __webpack_public_path__ + "img/magento-support-security.8a8c10ff.jpeg";